import { useEffect } from "react";

export default function useFadeMapLayer(mapLayerRef, show){
    useEffect(()=>{
        let destroyed = false;
        let opacity = show?0:1;
        function tick(){
            // console.debug('tick', opacity);
            if(destroyed || !mapLayerRef.current) return;
            if((show && opacity < 1) || (!show && opacity > 0)){
                opacity += (0.1 * (show?1:-1));
                if(opacity > 1) opacity = 1;
                if(opacity < 0) opacity = 0;
                mapLayerRef.current.setOpacity(opacity);
            }else{
                return;
            }
            requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        return ()=>{
            destroyed = true;
        }
    },[show, mapLayerRef]);
}